export const registration = {
  registerHeader: "Register for an Account",
  adjusterHeader: "Register for an Adjuster Account",
  registerButtonText: "Register",
  backToLoginPage: "Back to login",
  syndication: "Register to view Syndication"
};
